<template>
    <v-container
            fluid
            tag="section"
            pt-0
    >
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :headers="headers"
                        :items="serviceImportancesDictionaryList"
                        sort-by="name"
                        class="elevation-1"
                >
                    <template v-slot:item.colorHex="{ item }">
                        <v-chip
                                :color="colorValue(item.colorHex)"
                                dark
                        >
                            {{ colorValue(item.colorHex) }}
                        </v-chip>
                    </template>
                    <template v-slot:top>
                        <v-toolbar
                                flat
                        >
                            <v-spacer></v-spacer>
                            <v-dialog
                                    v-model="dialog"
                                    max-width="500px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                    >
                                        {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-form
                                                ref="form"
                                                v-model="valid"
                                                lazy-validation
                                        >
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                            cols="12"
                                                    >
                                                        <v-text-field
                                                                v-model="editedItem.name"
                                                                :label="$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.nameTitle')"
                                                                :rules="[fieldValidationRules.required(vue), fieldValidationRules.maxLength(vue, 64)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="12"
                                                            sm="6"
                                                    >
                                                        <v-color-picker
                                                                disabled
                                                                hide-canvas
                                                                hide-inputs
                                                                hide-mode-switch
                                                                show-swatches
                                                                swatches-max-height="118"
                                                                v-model="editedItem.colorHex"
                                                                :label="$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.color')"
                                                                :rules="[fieldValidationRules.required(vue)]"
                                                        ></v-color-picker>
                                                    </v-col>
                                                    <v-col
                                                            cols="12"
                                                            sm="6"
                                                    >
                                                        <v-menu
                                                                ref="menu"
                                                                v-model="menu"
                                                                :close-on-content-click="false"
                                                                :nudge-right="40"
                                                                :return-value.sync="editedItem.maxResolveTime"
                                                                transition="scale-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                        v-model="editedItem.maxResolveTime"
                                                                        :label="$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.maxResolveTime')"
                                                                        :rules="[fieldValidationRules.required(vue)]"
                                                                        prepend-icon="mdi-clock-time-four-outline"
                                                                        readonly
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-time-picker
                                                                    v-if="menu"
                                                                    v-model="editedItem.maxResolveTime"
                                                                    format="24hr"
                                                                    full-width
                                                                    @click:minute="$refs.menu.save(editedItem.maxResolveTime)"
                                                            ></v-time-picker>
                                                        </v-menu>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="close"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                        </v-btn>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="save"
                                                :loading="axiosLoading" :disabled="!valid"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card>
                                    <v-card-title class="headline">{{$vuetify.lang.t('$vuetify.page.all.deleteMsg')}}
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="closeDelete">
                                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="deleteItemConfirm" :loading="axiosLoading">
                                            {{$vuetify.lang.t('$vuetify.page.action.btnYes')}}
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                                small
                                @click="deleteItem(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        Нет данных
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "ServiceImportanceList",
        created() {
            this.$store.dispatch('retrieveServiceImportanceDictionary', null)
            this.$store.dispatch('retrieveServiceImportanceDictionaryList')
        },
        computed: {
            ...mapState(['barColor', 'barImage']),
            serviceImportancesDictionaryList() {
                return this.$store.getters.serviceImportanceDictionaryList
            },
            currentServiceImportanceDictionary() {
                return this.$store.getters.currentServiceImportanceDictionary
            },
            formTitle() {
                return this.editedIndex === -1
                    ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.crudName'))
                    : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.crudName'))
            },
            formError(){
                return this.$store.getters.error
            }
        },
        data() {
            return {
                currentServiceImportanceDictionaryId: null,
                dialog: false,
                dialogDelete: false,
                valid: !this.formError,
                vue: this,
                time: null,
                menu: false,
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.nameTitle'),
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.color'),
                        align: 'start',
                        sortable: true,
                        value: 'colorHex',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.ServiceImportanceDictionary.maxResolveTime'),
                        align: 'start',
                        sortable: true,
                        value: 'maxResolveTime',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.page.action.titleAction'), value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    id: null,
                    name: null,
                    colorHex: null,
                    maxResolveTime: '1:00'
                },
                defaultItem: {
                    id: null,
                    name: null,
                    colorHex: null,
                    maxResolveTime: '1:00'
                },
            }
        },
        methods: {
            colorValue(val){
                if(val.hexa){
                    return val.hexa
                } else {
                    return val
                }
            },
            getServiceImportanceDictionary(entityId) {
                if (entityId) {
                    this.currentServiceImportanceDictionaryId = entityId
                    this.$store.dispatch('retrieveServiceImportanceDictionary', entityId)
                }
            },
            editItem(item) {
                this.editedIndex = this.serviceImportancesDictionaryList.indexOf(item)

                this.editedItem = Object.assign({}, item)
                this.editedItem.isUpdate = true
                this.dialog = true
            },

            deleteItem(item) {
                this.editedIndex = this.serviceImportancesDictionaryList.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm() {
                let entity = this.serviceImportancesDictionaryList[this.editedIndex]

                this.$store.dispatch('deleteServiceImportanceDictionary', entity.id).then(() => this.closeDelete())
            },

            close() {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            save() {
                if (this.$refs.form.validate()) {
                    if (!this.editedItem.id) {
                        this.editedItem.id = this.$uuid.v4()
                        this.editedItem.isUpdate = false
                    }
                    this.$store.dispatch('setServiceImportanceDictionary', this.editedItem).then(() => this.close())
                }
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            dialogDelete(val) {
                val || this.closeDelete()
            },
        },
    }
</script>

<style scoped>

</style>